import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withRadium, DetectCompact } from 'higher-order-components'
import { DEFAULT_THRESHOLD_NORMAL } from 'constants/layout'
import { AccordionText } from 'AtomicContainers'
import { Button, H6, H3, Interactive, Content, Space } from 'AtomicComponents';

const Underline = () => <div style={{ borderBottom: 'solid #910A2D 3px', width: '100%' }} />

class OfferTile extends PureComponent {
  renderButton = () => {
    const {
      components, nameplateTitle, bodyGradeTitle, heading
    } = this.props
    const buttons = components.map((button, index) => (
      <div style={{ margin: "0 1em 1em 0"}}>
        <Button
          key={index}
          {...button.props}
          gtm={{
            category: "Offers",
            action: `"${nameplateTitle} / ${bodyGradeTitle} / ${heading}" - Clicked CTA - "${button.props.label.toUpperCase()}"`
          }} />
      </div>
    ))

    return buttons
  }

  render() {
    const {
      slug,
      compact,
      heading,
      preHeading,
      subHeading,
      offerPoints,
      featuresAccordion,
      imageSrc,
      nameplateTitle,
      bodyGradeTitle
    } = this.props
    return (
      <div data-name={slug.slice(1)} style={styles.base} data-test={'offer-item'}>
        <div style={styles.innerContainer}>
          <div data-test="offer-left-block" style={styles.left} data-koala-offer-slug={slug}>
            <H6 withDetails>{preHeading}</H6>
            <H3 withDetails>
              <span style={{ display: 'inline-block', fontSize: "inherit", lineHeight: "inherit" }}>
                {heading}
                <Underline />
              </span>
            </H3>
            {
              subHeading &&
              <div>
                <Space />
                <Interactive>{subHeading}</Interactive>
              </div>
            }
            {offerPoints && (
              <div style={styles.offerPoints}>
                <Content textAlign="left" xmlString={offerPoints} />
              </div>
            )}
            {featuresAccordion && (
              <div style={styles.features}>
                <AccordionText
                  styleName='info'
                  alwaysOpen={false}
                  name="Features"
                  gtm={{
                    category: "Offers",
                    action: `"${nameplateTitle} / ${bodyGradeTitle} / ${heading}" - Features`
                  }}>
                  <div style={{ padding: '1em' }}>
                    <Content xmlString={featuresAccordion} />
                  </div>
                </AccordionText>
              </div>
            )}
            <div style={styles.buttons(compact)}>{this.renderButton()}</div>
          </div>
          <div data-test="offers-right-block" style={styles.right}>
            <div style={styles.nameplateTitleDesktop}>
              <H3 withDetails>{nameplateTitle}</H3>
              <Interactive>{bodyGradeTitle}</Interactive>
            </div>
            <img style={{ width: '100%' }} src={imageSrc} alt={heading} />
          </div>
        </div>
      </div>
    )
  }
}

OfferTile.propTypes = {
  children: PropTypes.node,
  components: PropTypes.array,
  slug: PropTypes.string,
  heading: PropTypes.string,
  preHeading: PropTypes.string,
  Interactive: PropTypes.string,
  nameplateTitle: PropTypes.string,
  featuresAccordion: PropTypes.string,
  offerPoints: PropTypes.string,
  imageSrc: PropTypes.string,
  bodyGradeTitle: PropTypes.string,
  compact: PropTypes.bool
}

export default withRadium(DetectCompact())(OfferTile)

const breakPointMobile = `@media (min-width: ${DEFAULT_THRESHOLD_NORMAL}px)`

const styles = {
  base: {
    backgroundColor: '#f5f5f5',
    border: 'solid #d5d5d5 1px'
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '70em',
    margin: 'auto',
    paddingTop: '2.5em',
    paddingBottom: '2.5em',
    paddingLeft: '1em',
    paddingRight: '1em',
    [breakPointMobile]: {
      paddingTop: '4.5em',
      paddingBottom: '2em',
      paddingLeft: '1em',
      paddingRight: '1em',
      flexDirection: 'row'
    }
  },
  features: {
    display: 'block'
  },
  offerPoints: {
    display: 'block',
    fontWeight: '300',
    lineHeight: '1.6',
    maxWidth: '70em',
    padding: '1em 0 .5em',
    textAlign: 'left'
  },
  left: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    textAlign: "center",
    order: 2,
    [breakPointMobile]: {
      order: 1,
      textAlign: "left",
      paddingRight: '3em',
      width: '60%'
    }
  },
  right: {
    width: '100%',
    textAlign: 'right',
    order: 1,
    [breakPointMobile]: {
      order: 2
    }
  },
  nameplateTitleDesktop: {
    [breakPointMobile]: {
      display: 'block'
    },
    textAlign: 'right',
    display: 'none'
  },
  nameplateTitleMobile: {
    [breakPointMobile]: {
      display: 'none'
    },
    textAlign: 'right',
    display: 'block'
  },
  buttons: compact => ({
    display: 'flex',
    flexDirection: compact ? 'column' : 'row',
    padding: '2em 0',
    marginRight: '-1em',
    width: '100%'
  })
}



// WEBPACK FOOTER //
// ./src/containers/offers/offer-tile.jsx